import styles from "./Layout.module.scss"
import Link from "next/link"

const Navigation = () => {
  return (
    <div className={styles.navigation}>
      <h5>Getting Started</h5>
      <ul>
        <li>
          <Link href="/ai/chat">Use Tombo AI</Link>
        </li>
        <li>
          <Link href="/schedule-tombo-demo">Schedule Technical Demo</Link>
        </li>
        <li>
          <Link href="/request-tombo-api">Request API Access</Link>
        </li>
        <li>
          <Link href="/host-tombo">Host Tombo AI Yourself</Link>
        </li>
      </ul>
      <h5>Join Us</h5>
      <ul>
        <li>
          <Link href="/apply/data-labeler">Data Labeler</Link>
        </li>
        <li>
          <Link href="/apply/developer">Developer</Link>
        </li>
        <li>
          <Link href="/apply/platform-partner">Platform Partner</Link>
        </li>
      </ul>
    </div>
  )
}

export default Navigation
